import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import masterData from './data';

const Master = () => {
  return <ProjectDetailView data={masterData} />;
};

export default Master;
